<template>
  <section>
    <div class="role">
      <div class="roleLeft" style="min-width:150px">
        <div :class="['roleLeft_List', 'clickTree' ]">
          <el-tree
              :data="treeList"
              node-key="advertiserDeptId"
              default-expand-all
              :expand-on-click-node="false"
              ref="adminTree"
              :props="defaultProps_one"
              @check="getstaffList"
              @node-click="getstaffList">
          </el-tree>
        </div>
      </div>
      <div class="roleRight">
        <div class="roleRight_Top">
          <el-input
              v-if="searchShow"
              clearable
              v-model="search.searchKey"
              clas="input_search"
              placeholder="搜索关键字"
              @keyup.enter.native="SearchAdminLsit"
          ></el-input>
          <el-select v-if="searchShow" v-model="search.status" clearable placeholder="请选择">
            <el-option label="正常" :value="1" key="1"></el-option>
            <el-option label="禁用" :value="0" key="0"></el-option>
          </el-select>
          <el-button v-if="searchShow" size="medium" type="primary" @click="SearchAdminLsit"
          >查询
          </el-button
          >
          <el-button
              v-if="addShow"
              size="medium"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              :data="tableData"
              border
              style="width: 100%"
              row-key="number"
              v-loading="loading"
          >
            <el-table-column
                fixed
                label="序号"
                prop="staffId"
                type="index"
                width="100"
            >
              <template slot-scope="scope">
                <span>{{
                    (page.pageNo - 1) * page.pageSize + scope.$index + 1
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="number" label="编号"></el-table-column>
            <el-table-column prop="name" label="姓名" min-width="120">
            </el-table-column>
            <el-table-column prop="account" label="账号" min-width="120">
            </el-table-column>
            <el-table-column prop="phone" label="手机号" min-width="130">
            </el-table-column>
            <el-table-column prop="advertiserDeptName" label="投放组" min-width="130"></el-table-column>
            <el-table-column prop="status" label="状态">
              <template slot-scope="scope">
                <el-switch
                    v-model="scope.row.status"
                    :active-value="1"
                    :disabled="scope.row.sysdba==1 && statusShow"
                    :inactive-value="0"
                    @change="handleSwitch(scope.row)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" align="left" min-width="200">
              <template slot-scope="scope">
                <div>
                  <el-button
                      v-if="editShow"
                      @click="handleClick('change', scope.row)"
                      plain
                      size="small"
                  >修改
                  </el-button
                  >
                  <el-button
                      v-if="launchShow"
                      type="danger"
                      size="small"
                      plain
                      @click="getChannelList(scope.row)"
                  >账号
                  </el-button
                  >
                  <el-button
                      v-if="deleteShow"
                      type="primary"
                      plain
                      size="small"
                      @click="del(scope.row)"
                  >删除
                  </el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="roleRight_pagenation">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageNo"
              :page-sizes="[PAGE_SIZE, 15, 20, 25]"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 新增投放专员弹框 -->
    <el-dialog
        title="新增投放专员"
        :visible.sync="adddDalogVisible"
        :close-on-click-modal="false"
        width="460px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="110px"
        >
          <el-form-item class="item" label="名称：">
            <el-select
                v-model="params.staffId"
                placeholder="请选择"
                clearable
                filterable
                ref="selectReport"
            >
              <el-option style="height: auto" :key="index" v-for="(item,index) in personnel" :label="item.name"
                         :value="item.staffId"></el-option>
            </el-select>
          </el-form-item>
          <el-row>
            <el-col :span="24" style="position: relative">
              <span class="clear_icon_items">*</span>
              <el-form-item label="投放组：" prop="dictDataSelect">
                <el-select
                    v-model="dictDataSelect"
                    placeholder="请选择"
                    clearable
                    filterable
                    ref="selectReport"
                >
                  <el-option style="height: auto" :value="dictDataSelect">
                    <el-tree
                        :data="treeList"
                        node-key="advertiserDeptId"
                        :props="orgsProps"
                        ref="orgsTree"
                        default-expand-all
                        :render-after-expand="true"
                        :expand-on-click-node="false"
                        @node-click="handleNodeClick"
                    ></el-tree>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
            <el-button size="medium" @click="adddDalogVisible = false"
            >取 消</el-button
            >
            <el-button size="medium" type="primary" @click="handleEdit"
            >提 交</el-button
            >
          </span>
    </el-dialog>
    <!-- 编辑弹框 -->
    <el-dialog
        title="编辑投放专员"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="560px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="110px"
        >

          <!-- 角色 菜单分配 -->
          <el-form-item class="item" label="员工："
          >{{ params.name }}（{{ params.number }}）
          </el-form-item>

          <el-form-item label="头像：">
            <div class="diplay" style="margin-right: 10px">
              <div class="screenshot">
                <span class="slideshow">
                  <el-image
                      style="width: 75px; height: 75px; border-radius: 6px"
                      :src="params.head"
                      fit="cover"
                  />
                </span>
              </div>
            </div>
          </el-form-item>
          <!-- 新增  修改 -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="账号：" prop="account">{{ params.account }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号：" prop="account">{{ params.phone }}</el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="position: relative">
              <span class="clear_icon_items">*</span>
              <el-form-item label="投放组：" prop="dictDataSelect">
                <el-select
                    v-model="dictDataSelect"
                    placeholder="请选择"
                    clearable
                    filterable
                    ref="selectReport"
                >
                  <el-option style="height: auto" :value="dictDataSelect">
                    <el-tree
                        :data="treeList"
                        node-key="advertiserDeptId"
                        :props="orgsProps"
                        ref="orgsTree"
                        default-expand-all
                        :render-after-expand="true"
                        :expand-on-click-node="false"
                        @node-click="handleNodeClick"
                    ></el-tree>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
    <!-- 第一个弹框渠道配置 -->
    <el-dialog
        :title="permissionType=='tf'?'投放账号管理':'查看账号管理'"
        :visible.sync="lookChannelDialogVisible"
        :close-on-click-modal="false"
        width="1120px"
        class="public-dialog"
    >
      <div style="cursor: pointer" class="public-dialog-form" v-loading="loading">
        <div style="display: flex">
          <div class="channel_items" style="align-items: center">
            <div class="titles">名称：</div>
            <div>{{ UserInformation.name }}({{ UserInformation.number }})</div>
          </div>
          <div class="channel_items" style="align-items: center">
            <div class="titles">投放组：</div>
            <div> {{ UserInformation.advertiserDeptName }}</div>
          </div>
        </div>
        <div class="channel_items" style="align-items: center">
          <div class="titles"></div>
          <el-tabs v-model="permissionType" @tab-click="hidenClickChannel">
            <el-tab-pane label="投放账户" name="tf"></el-tab-pane>
            <el-tab-pane label="查看账户" name="ck"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="channel_items" style="align-items: center">
          <div class="titles"></div>
          <el-button type="primary" @click="changBindShow">去绑定</el-button>
          <el-button type="primary" @click="deleteBindAccount('all')">解绑选中项</el-button>
        </div>
        <div class="channel_items">
          <div class="titles">已绑定：</div>
          <div class="table_cou">
            <div class="tab_header_th">
              <div class="names">渠道</div>
              <div class="inde_auto _chang_aoutis" @click="changAllCheck">
                <span class="check_box" :class="{'is-checked':allChecked}"></span>
              </div>
              <div class="inde_auto">序号</div>
              <div class="name_box_auto">名称</div>
              <div class="comtemts">账号</div>
              <div class="code_box">标识</div>
              <div class="post_inof">投放方式</div>
              <div class="code_box">说明</div>
              <div class="qutuns">状态</div>
              <div class="qutuns">操作</div>
            </div>
            <div class="tab_body_content">
              <div class="tab_content_td" v-if="item.advertiserChannels.length"
                   v-for="(item,index) in accountnNumberList"
                   :key="index">
                <div class="left_contents">{{ item.channelTypeName }}</div>
                <div class="right_contents">
                  <div class="right_items" v-for="(items,indexs) in item.advertiserChannels" :key="indexs">
                    <div class="account_index _chang_aoutis" @click="changCheck(index,indexs)">
                      <span class="check_box" :class="{'is-checked':items.check}"></span>
                    </div>
                    <div class="account_index">{{ indexs + 1 }}</div>
                    <div class="account_box" @click="bindInfo(items)">{{ items.name }}</div>
                    <div class="account_name">{{ items.account }}</div>
                    <div class="account_code">{{ items.code }}</div>
                    <div class="account_putWay">{{ items.putWayName }}</div>
                    <div class="account_des">{{ items.descr }}</div>
                    <div class="contun_box_c disabled_tab">
                      <span class="box_icons"
                            :class="{'active_none':items.status==0}">{{ items.status ? '启用' : '禁用' }}</span>
                    </div>
                    <div class="contun_box_c">
                      <el-button @click="deleteBindAccount('single',items)" size="mini" type="text" plain>解绑</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 渠道绑定 -->
    <el-dialog
        :title="permissionType=='tf'?'投放账号绑定':'查看账号绑定'"
        :visible.sync="releaseAccountBinding"
        :close-on-click-modal="false"
        width="1120px"
        class="public-dialog"
    >
      <div style="cursor: pointer" class="public-dialog-form" v-loading="loading">
        <div style="display: flex">
          <div class="channel_items" style="align-items: center">
            <div class="titles">名称：</div>
            <div>{{ UserInformation.name }}({{ UserInformation.number }})</div>
          </div>
          <div class="channel_items" style="align-items: center">
            <div class="titles">投放组：</div>
            <div> {{ UserInformation.advertiserDeptName }}</div>
          </div>
        </div>
        <div class="channel_items" style="align-items: center">
          <div class="titles"></div>
          <el-button type="primary" @click="addBindAccount('all')">添加选中项</el-button>
        </div>
        <div class="channel_items" style="cursor: pointer">
          <div class="titles">渠道账户：</div>
          <div class="table_cou">
            <div class="tab_header_th">
              <div class="names">渠道</div>
              <div class="inde_auto _chang_aoutis" @click="changAllChannelCheck">
                <span class="check_box" :class="{'is-checked':channelAllChecked}"></span>
              </div>
              <div class="inde_auto">序号</div>
              <div class="name_box_auto">名称</div>
              <div class="comtemts">账号</div>
              <div class="code_box">标识</div>
              <div class="post_inof">投放方式</div>
              <div class="code_box">说明</div>
              <div class="qutuns">状态</div>
              <div class="qutuns">操作</div>
            </div>
            <div class="tab_body_content">
              <div class="tab_content_td" v-if="item.advertiserChannels.length" v-for="(item,index) in channelList"
                   :key="index">
                <div class="left_contents">{{ item.channelTypeName }}</div>
                <div class="right_contents">
                  <div class="right_items" v-for="(items,indexs) in item.advertiserChannels" :key="indexs">
                    <div class="account_index _chang_aoutis" @click="changChannelCheck(index,indexs)">
                      <span class="check_box" :class="{'is-checked':items.check}"></span>
                    </div>
                    <div class="account_index">{{ indexs + 1 }}</div>
                    <div class="account_box" @click="bindInfo(items)">{{ items.name }}</div>
                    <div class="account_name">{{ items.account }}</div>
                    <div class="account_code">{{ items.code }}</div>
                    <div class="account_putWay">{{ items.putWayName }}</div>
                    <div class="account_des">{{ items.descr }}</div>
                    <div class="contun_box_c disabled_tab">
                      <span class="box_icons"
                            :class="{'active_none':items.status==0}">{{ items.status ? '启用' : '禁用' }}</span>
                    </div>
                    <div class="contun_box_c">
                      <el-button v-if="items.bind==0" @click="addBindAccount('single',items)" size="mini" type="text" plain>添加
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!--绑定信息详情-->
    <el-dialog
        title="绑定信息"
        :visible.sync="bindingInfo"
        :close-on-click-modal="false"
        width="580px"
        class="public-dialog"
    >
      <div class="public-dialog-form" v-loading="loading" style="padding-bottom:15px">
        <div class="items">
          <div class="left_name">名称：</div>
          <div class="right_content">{{ accountBindInfo.channelTypeName }}（{{ accountBindInfo.code }}）</div>
        </div>
        <div class="info_tab_tas">
          <div class="items">
            <div class="left_name"> 账号：</div>
            <div class="right_content">{{ accountBindInfo.account }}</div>
          </div>
          <div class="items">
            <div class="left_name">投放方式：</div>
            <div class="right_content">{{ accountBindInfo.putWayName }}</div>
          </div>
        </div>
        <div class="items" v-if="accountBindInfo.orgName">
          <div class="left_name">绑定部门：</div>
          <div class="right_content">{{ accountBindInfo.orgName }}</div>
        </div>
        <div class="items" v-if="accountBindInfo.number">
          <div class="left_name">绑定业务员：</div>
          <div class="right_content">{{ accountBindInfo.name }}（{{ accountBindInfo.number }}）</div>
        </div>
      </div>
    </el-dialog>
    <!-- 渠道配置 -->
    <el-dialog
        :title="permissionType=='tf'?'投放账号管理':'查看账号管理'"
        :visible.sync="channelDialogVisible"
        :close-on-click-modal="false"
        width="1070px"
        class="public-dialog"
    >
      <div style="cursor: pointer" class="public-dialog-form" v-loading="loading">
        <div style="display: flex">
          <div class="channel_items" style="align-items: center">
            <div class="titles">名称：</div>
            <div>{{ UserInformation.name }}({{ UserInformation.number }})</div>
          </div>
          <div class="channel_items" style="align-items: center">
            <div class="titles">投放组：</div>
            <div> {{ UserInformation.advertiserDeptName }}</div>
          </div>
        </div>
        <div class="channel_items" style="align-items: center">
          <div class="titles"></div>
          <el-button type="primary" @click="changBindShow">绑定</el-button>
        </div>
        <div class="channel_items">
          <div class="titles">渠道账户：</div>
          <div class="table_cou">
            <div class="tab_header_th">
              <div class="names">渠道</div>
              <div class="inde_auto">序号</div>
              <div class="name_box_auto">名称</div>
              <div class="comtemts">账号</div>
              <div class="code_box">标识</div>
              <div class="post_inof">投放方式</div>
              <div class="code_box">说明</div>
              <div class="qutuns">状态</div>
              <div class="qutuns">操作</div>
            </div>
            <div class="tab_body_content">
              <div class="tab_content_td" v-if="item.advertiserChannels.length"
                   v-for="(item,index) in accountnNumberList"
                   :key="index">
                <div class="left_contents">{{ item.channelTypeName }}</div>
                <div class="right_contents">
                  <div class="right_items" v-for="(items,indexs) in item.advertiserChannels" :key="indexs">
                    <div class="account_index">{{ indexs + 1 }}</div>
                    <div class="account_box" @click="bindInfo(items)">{{ items.name }}</div>
                    <div class="account_name">{{ items.account }}</div>
                    <div class="account_code">{{ items.code }}</div>
                    <div class="account_putWay">{{ items.putWayName }}</div>
                    <div class="account_des">{{ items.descr }}</div>
                    <div class="contun_box_c disabled_tab">
                      <span class="box_icons"
                            :class="{'active_none':items.status==0}">{{ items.status ? '启用' : '禁用' }}</span>
                    </div>
                    <div class="contun_box_c">
                      <el-button @click="deleteBindAccount(items)" size="mini" type="text" plain>解绑</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import {PAGE_SIZE, COMMON_STATUS} from "@/config";
import {ossUpload} from "@utils/filters/upload";

export default {
  data() {
    var checkAccount = (rule, value, callback) => {
      if (value) {
        if (/[^\w\.\/]/gi.test(value)) {
          callback(new Error("请不要输入中文和空格！"));
        } else {
          callback();
        }
      }
      callback();
    };
    return {
      PAGE_SIZE,
      COMMON_STATUS,
      loading: false,
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      pageCount: 0,
      search: {},
      dialogVisible: false, //弹出框显示隐藏
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      rules: {
        account: [
          {required: true, message: "请填写账号"},
          {max: 10, message: "最多10个字符"},
          {validator: checkAccount, trigger: "blur"},
        ],
        name: [
          {required: true, message: "请填写姓名"},
        ],
        phone: [
          {required: true, message: "请填写手机号码"},
          {min: 11, max: 11, message: "手机号为11个字符", trigger: "change"},
          {
            pattern:
                /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
            message: "请输入正确的手机号码",
          },
        ],
      }, //表单验证提示
      tableData: [], //二级--管理员列表
      trees: {
        tree: true,
      },
      treeList: [], //left Tree
      defaultProps_one: {
        children: "children",
        label: "name",
      }, //最左边显示的组织树--
      orgsProps: {
        children: "children",
        label: "name",
      }, //组织的树--弹窗
      defaultProps: {
        children: "children",
        label: "name",
      }, //角色树--弹窗
      orgData: [], //组织和岗位
      posData: [], //组织和岗位
      dictDataSelect: "", //弹窗选择的组织
      positionDataSelect: "", //弹窗选择的岗位
      isTreeCheck: true, //左侧树是否激活点击
      activeID: -1,// 激活样式
      channelDialogVisible: false,
      UserInformation: {},
      channelList: [],
      accountnNumberList: [],
      releaseAccountBinding: false,
      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,
      launchShow: false,
      roleShow: false,
      resetShow: false,
      srcList: [],
      isMoer: true,
      bindingInfo: false,
      accountBindInfo: {},
      adddDalogVisible: false,

      personnel: [],

      addParmerts: {},

      lookChannelDialogVisible: false,
      permissionType: 'tf',

      allChecked:false,

      channelAllChecked:false
    };
  },
  created() {
    this.getOrgAndPosi(); //获取组织和岗位的列表
    this.getstaffList();  //获取投放专员的数据列表
    this.getPermissionButtonList()  //权限设置
    this.getStaffListMeun() //获取所有的员工数据
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.dictDataSelect = ""; //清空选择的组织
        this.positionDataSelect = ""; //清空选择的岗位
      }
    },
    search: {
      handler(val) {
      },
      deep: true,
    },
  },
  methods: {
    //权限
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'launch:specia:account') {
            this.launchShow = true
          }
          if (item.code == 'launch:specia:query') {
            this.searchShow = true
          }
          if (item.code == 'launch:specia:add') {
            this.addShow = true
          }
          if (item.code == "launch:specia:delete") {
            this.deleteShow = true
          }
          if (item.code == "launch:specia:edit") {
            this.editShow = true
          }
          if (item.code == "launch:specia:status") {
            this.statusShow = false
          }
        })
      }
    },
    // 绑定相关业务处理  start-----
    async bindInfo(e) {
      this.loading = true;
      const {data: resData} = await this.$get(`/channel/account/bind/info?channelAccountId=` + e.channelAccountId);
      if (resData.result != 200) {
        this.loading = false;
        return
      }
      this.loading = false;
      this.accountBindInfo = resData.data
      this.bindingInfo = true
    },
    // 解除绑定
    deleteBindAccount(type,e) {
      let arr = []
      if(type=='single'){
        arr.push(e.channelAccountId)
      }
      if(type=='all'){
        this.accountnNumberList.map(item => {
          if(item.advertiserChannels){
            item.advertiserChannels.map(items=>{
              if(items.check){
                arr.push(items.channelAccountId)
              }
            })
          }
        })
      }
      if(arr.length){
        this.$confirm("确认解除当前绑定账号, 是否继续?", "提示", {
          type: "warning",
        }).then(async () => {
          const {data: resData} = await this.$delete("/advertiser/channel/bind/status",
              {
                data: {
                  channelAccountIds: arr,
                  advertiserId: this.UserInformation.advertiserId,
                  permissionType: this.permissionType
                }
              },
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.getChannelList(this.UserInformation)
          this.changBindShow(1)
          this.releaseAccountBinding = false
          this.$message.success("解绑成功!");
        })
      }else {
        this.$message.warning('请选择需要解绑的渠道')
      }
    },
    // 绑定账号？
    addBindAccount(type,e) {
      let arr = []
      if(type=='single'){
        arr.push(e.channelAccountId)
      }
      if(type=='all'){
        this.channelList.map(item => {
          if(item.advertiserChannels){
            item.advertiserChannels.map(items=>{
              if(items.check){
                arr.push(items.channelAccountId)
              }
            })
          }
        })
      }
      if(arr.length<=0){
        this.$message.warning('请选择需要添加的渠道')
        return
      }
      let obj = {
        channelAccountIds: arr,
        advertiserId: this.UserInformation.advertiserId,
        permissionType: this.permissionType
      }
      this.$confirm("确认绑定当前投放账号, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        const {data: resData} = await this.$post(
            "/advertiser/channel/bind/status",
            obj,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getChannelList(this.UserInformation)
        this.changBindShow()
        this.$message.success("添加成功!");
      })
    },
    //可绑定列表
    async changBindShow(e) {
      this.loading = true;
      const {data: resData} = await this.$get(`/advertiser/channel/list?permissionType=` + this.permissionType + `&advertiserId=` + this.UserInformation.advertiserId);
      if (resData.result != 200) {
        this.loading = false;
        return
      }
      this.loading = false;
      if(resData.data){
        resData.data.map(item=>{
          item.parentCheck = false
          if(item.advertiserChannels){
            item.advertiserChannels.map(items=>{
              items.check = false
            })
          }else {
            item.parentCheck = true
          }
        })
        this.channelList = resData.data
      }else {
        this.channelList = []
      }
      // this.channelList = resData.data
      if (e != 1) {
        this.releaseAccountBinding = true
      }
    },
    //已绑定的账号
    async getChannelList(e) {
      this.loading = true;
      this.UserInformation = e
      const {data: resData} = await this.$get(`/advertiser/channel/bind/list`, {
        params: {advertiserId: this.UserInformation.advertiserId, permissionType: this.permissionType}
      });
      if (resData.result != 200) {
        this.loading = false;
        return
      }
      this.loading = false;
      if(resData.data){
        resData.data.map(item=>{
          item.parentCheck = false
          if(item.advertiserChannels){
            item.advertiserChannels.map(items=>{
              items.check = false
            })
          }
        })
        this.accountnNumberList = resData.data
      }else {
        this.accountnNumberList = []
      }
      // if()
      this.lookChannelDialogVisible = true
    },


    changCheck(index,item_index){
      this.accountnNumberList[index].advertiserChannels[item_index].check = !this.accountnNumberList[index].advertiserChannels[item_index].check
      this.changChild(this.accountnNumberList[index].advertiserChannels,this.accountnNumberList[index])
    },

    changChild(e,item){
      // 当子选项全选中时 全选按钮也要选中 反之则不选中
      let arrTrue = []  // 定义两个空数组 当子选项是选中的状态则放入arrTrue数组中反之放进arrFalse里
      let arrFalse = []
      e.map(items => {
        if (items.check) {
          arrTrue.push(items.check)
        } else {
          arrFalse.push(items.check)
        }
      })
      if (arrTrue.length == e.length) {
        item.parentCheck = true
      }
      // 当arrFalse 长度大于0时 说明其中有 没有勾选的子选项
      if (arrFalse.length > 0) {
        item.parentCheck = false
      }

      this.changParent()
    },

    changParent(){
      // 当子选项全选中时 全选按钮也要选中 反之则不选中
      let arrTrue = []  // 定义两个空数组 当子选项是选中的状态则放入arrTrue数组中反之放进arrFalse里
      let arrFalse = []
      this.accountnNumberList.map(items => {
        if (items.parentCheck) {
          arrTrue.push(items.check)
        } else {
          arrFalse.push(items.check)
        }
      })
      if (arrTrue.length == this.accountnNumberList.length) {
        this.allChecked = true
      }
      // 当arrFalse 长度大于0时 说明其中有 没有勾选的子选项
      if (arrFalse.length > 0) {
        this.allChecked = false
      }
    },

    changAllCheck(){
      this.allChecked = !this.allChecked
      if(this.allChecked){
        this.accountnNumberList.map(item => {
          item.parentCheck = true
          if(item.advertiserChannels){
            item.advertiserChannels.map(items=>{
              items.check = true
            })
          }
        })
      }
      if(!this.allChecked){
        this.accountnNumberList.map(item => {
          item.parentCheck = false
          if(item.advertiserChannels){
            item.advertiserChannels.map(items=>{
              items.check = false
            })
          }
        })
      }
    },


    //可绑定列表选择
    changChannelCheck(index,item_index){
      this.channelList[index].advertiserChannels[item_index].check = !this.channelList[index].advertiserChannels[item_index].check
      this.changChannelChild(this.channelList[index].advertiserChannels,this.channelList[index])
    },

    changChannelChild(e,item){
      // 当子选项全选中时 全选按钮也要选中 反之则不选中
      let arrTrue = []  // 定义两个空数组 当子选项是选中的状态则放入arrTrue数组中反之放进arrFalse里
      let arrFalse = []
      e.map(items => {
        if (items.check) {
          arrTrue.push(items.check)
        } else {
          arrFalse.push(items.check)
        }
      })
      if (arrTrue.length == e.length) {
        item.parentCheck = true
      }

      // 当arrFalse 长度大于0时 说明其中有 没有勾选的子选项
      if (arrFalse.length > 0) {
        item.parentCheck = false
      }
      this.changChannelParent()
    },

    changChannelParent(){
      // 当子选项全选中时 全选按钮也要选中 反之则不选中
      let arrTrue = []  // 定义两个空数组 当子选项是选中的状态则放入arrTrue数组中反之放进arrFalse里
      let arrFalse = []
      this.channelList.map(items => {
        if (items.parentCheck) {
          arrTrue.push(items.check)
        } else {
          arrFalse.push(items.check)
        }
      })
      if (arrTrue.length == this.channelList.length) {
        this.channelAllChecked = true
      }
      // 当arrFalse 长度大于0时 说明其中有 没有勾选的子选项
      if (arrFalse.length > 0) {
        this.channelAllChecked = false
      }
    },

    changAllChannelCheck(){
      this.channelAllChecked = !this.channelAllChecked
      if(this.channelAllChecked){
        this.channelList.map(item => {
          item.parentCheck = true
          if(item.advertiserChannels){
            item.advertiserChannels.map(items=>{
              items.check = true
            })
          }
        })
      }
      if(!this.channelAllChecked){
        this.channelList.map(item => {
          item.parentCheck = false
          if(item.advertiserChannels){
            item.advertiserChannels.map(items=>{
              items.check = false
            })
          }
        })
      }
    },



    //绑定类型切换
    hidenClickChannel() {
      this.allChecked = false
      this.getChannelList(this.UserInformation)
    },
    //
    changBindChannelShow() {
      this.channelDialogVisible = true
    },
    // -------end 绑定相关
    // 获取投放组树
    async getOrgAndPosi() {
      const {data: orgData} = await this.$get(`/advertiser/dept/list?tree=true&paging=false`);
      // 赋值左侧投放组树和投放组数据
      this.treeList = orgData.data;
    },
    //获取所有的员工列表
    async getStaffListMeun() {
      let http = `/staff/list?paging=false&nodeLevel=2`;
      this.loading = true;
      const {data: res} = await this.$get(
          http,
          {
            headers: {
              isLoading: true,
            },
          }
      );
      this.loading = false;
      this.personnel = res.data;
    },
    //投放列表
    async getstaffList(node) {
      let http = `/advertiser/list`;
      if (node && node.advertiserDeptId) {
        this.isTreeCheck == true;
        http = `${http}?advertiserDeptId=${node.advertiserDeptId}`;
      } else {
        this.isTreeCheck = false;
      }
      this.loading = true;
      const {data: res} = await this.$get(
          http,
          {params: {...this.search, ...this.page}},
          {
            headers: {
              isLoading: true,
            },
          }
      );
      let arr = []
      if(res.data){
        res.data.map(item=>{
          if(item){
            arr.push(item)
          }
        })
      }
      this.loading = false;
      this.tableData = arr;
      this.pageCount = res.page.count;
    },
    //switch状态改变 --接口 修改管理员状态
    handleSwitch(row) {
      this.$put(`/advertiser/info/status/${row.advertiserId}`).then(res => {
        if (res.data.result == 200) {
          this.$message.success('操作成功')
        }
      });
    },
    //点击投放组
    handleNodeClick: function (node) {
      this.dictDataSelect = node.name;
      this.params.advertiserDeptId = node.advertiserDeptId;
      this.$refs.selectReport.blur();
    },
    //新增编辑专员弹窗
    handleClick(type, row = {}) {
      this.clickType = type;
      if (type == "change") {
        this.params = {};
        this.params = JSON.parse(JSON.stringify(row)); //这里修改了 深拷贝
        if (row.advertiserDeptName) {
          //暂定选择一个组织
          this.dictDataSelect = row.advertiserDeptName;
        }
        this.dialogVisible = true;
      } else {
        //添加
        this.params = {};
        this.adddDalogVisible = true
      }
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        if (this.clickType == "addNext") {
          if (!this.params.staffId) {
            this.$message.error('请选择员工')
            return;
          }
        }
        if (!this.params.advertiserDeptId) {
          this.$message.error('请选择投放组')
          return;
        }
        let obj = {
          advertiserDeptId: this.params.advertiserDeptId,
          advertiserId: this.params.advertiserId,
          staffId: this.params.staffId,
        }
        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "addNext") {
            const {data: resData} = await this.$post(
                "/advertiser/info",
                obj,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.getstaffList();
            this.adddDalogVisible = false; //弹窗隐藏
            this.$message.success("添加成功!");
          } else {
            const {data: resData} = await this.$put(
                "/advertiser/info",
                obj,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.getstaffList();
            this.dialogVisible = false; //弹窗隐藏
            this.$message.success("修改成功!");
          }
        });
      });
    },
    //删除
    del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/advertiser/info/${row.advertiserId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getstaffList();
        this.$message.success("删除成功!");
      });
    },
    //查询专员
    SearchAdminLsit() {
      this.page.pageNo = 1
      this.getstaffList()
    },
    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getstaffList();
    },

    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getstaffList();
    },
  },
};
</script>
<style lang="scss" scoped>
.clear_icon_items {
  color: #F56C6C;
  position: absolute;
  left: 30px;
  top: 32%;
  transform: translateY(-50%);
}

.role {
  display: flex;
  // gap: 20px;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Left {
    padding-right: 15px;

    &_List {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
  }

  &Right {
    flex: 1;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    border-left: 1px solid #ccc;
    padding-left: 15px;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}

.dialog-tree {
  max-height: 420px;
  overflow-y: auto;
}

.role .el-button--small, .el-button--small.is-round {
  padding: 5px 10px !important;
}

.channel_items {
  display: flex;
  margin-bottom: 15px;

  .titles {
    width: 80px;
    text-align: right;
  }
}

.table_cou {
  height: auto;
  width: calc(100% - 80px);

  .tab_header_th {
    height: 30px;
    border: 1px solid rgba(231, 231, 231, 1);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      height: 30px;
      text-align: center;
      line-height: 30px;
      border-left: 1px solid rgba(231, 231, 231, 1);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .qutuns {
      width: 100px;
    }

    .names {
      width: 80px;
    }

    .name_box_auto {
      width: 220px;
    }

    .code_box {
      width: 100px;
    }

    .post_inof {
      width: 80px;
    }

    .inde_auto {
      width: 50px;
    }

    .comtemts {
      width: 120px;
    }
  }

  .tab_body_content {
    .tab_content_td {
      display: flex;
      border: 1px solid rgba(231, 231, 231, 1);
      border-top: none;
      box-sizing: border-box;
      min-height: 30px;
      border-bottom: none;
    }

    .right_contents {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: calc(100% - 80px);

      .right_items {
        display: flex;
        align-items: center;
        width: 100%;
        min-height: 30px;
        border-bottom: 1px solid rgba(231, 231, 231, 1);

        div {
          height: 30px;
          line-height: 30px;
          text-align: center;
          border-left: 1px solid rgba(231, 231, 231, 1);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .account_index {
          width: 50px;
        }
      }

      .account_box {
        width: 200px;
        padding: 0 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left !important;
      }

      .contun_box_c {
        width: 100px;
        border-left: 1px solid rgba(231, 231, 231, 1);

        .box_icons {
          padding: 5px 10px;
          font-size: 12px;
          color: #ffffff;
          background-color: #3a8ee6;
          border-radius: 4px;
        }

        .active_none {
          background-color: rgba(0, 0, 0, 0.1);
          color: #606266;
        }
      }

      .account_name {
        width: 100px;
        padding: 0 10px;
      }

      .account_code {
        width: 100px;
      }

      .account_putWay {
        width: 80px;
      }

      .account_des {
        width: 100px;
      }
    }

    .left_contents {
      width: 80px;
      border-bottom: 1px solid rgba(231, 231, 231, 1);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.items {
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  .left_name {
    width: 120px;
    text-align: right;

  }
}

.info_tab_tas {
  display: flex;
  align-items: center;
}

._chang_aoutis {
  display: flex;
  align-items: center;
  justify-content: center;
}

.check_box {
  display: inline-block;
  position: relative;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  background-color: #fff;
  z-index: 1;
  transition: border-color .25s cubic-bezier(.71, -.46, .29, 1.46), background-color .25s cubic-bezier(.71, -.46, .29, 1.46);
}

.check_box:after {
  box-sizing: content-box;
  content: "";
  border: 1px solid #fff;
  border-left: 0;
  border-top: 0;
  height: 7px;
  left: 4px;
  position: absolute;
  top: 1px;
  transform: rotate(45deg) scaleY(0);
  width: 3px;
  transition: transform .15s ease-in .05s;
  transform-origin: center;
}

.table_cou .is-checked:after {
  transform: rotate(45deg) scaleY(1);
}

.table_cou .is-checked {
  background-color: #409eff;
  border-color: #409eff;
}

</style>

<style>
.channel_items .el-tabs__nav-wrap {
  width: 270px !important;
}

.channel_items .el-tabs__nav {
  width: 100% !important;
}

.channel_items .el-tabs__item {
  width: 50%;
  padding: 0 !important;
  text-align: center;
  font-weight: 600;
}

.channel_items .el-tabs__active-bar {
  height: 1px !important;
}

.channel_items .el-tabs__nav-wrap::after {
  height: 1px !important;
}

/*.content .el-tabs__nav-scroll{*/
/*  width: 270px !important;*/
/*}*/
</style>